import { render, staticRenderFns } from "./ImpactOfDisability.vue?vue&type=template&id=9d3d9ec0&scoped=true"
import script from "./ImpactOfDisability.vue?vue&type=script&lang=js"
export * from "./ImpactOfDisability.vue?vue&type=script&lang=js"
import style0 from "./ImpactOfDisability.vue?vue&type=style&index=0&id=9d3d9ec0&prod&scoped=true&lang=less"
import style1 from "./ImpactOfDisability.vue?vue&type=style&index=1&id=9d3d9ec0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3d9ec0",
  null
  
)

export default component.exports